module.exports = __webpack_public_path__ + "img/SQM.1cf58f22.jpg";